// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"47d97ca7","498":"47d97ca7"}[chunkId] + ".chunk.css";
};